
import * as handlebars_family from "../handlebars_family.js";
import "../widget/form/checkbox-master.js";
import "../widget/form/checkbox.js";
const TPL = handlebars_family.addTemplate("mealplanner/modal_shopit_content",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <label class=\"blockmargin\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.pickforexport",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":83}}}))
    + "</label> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dishes") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":92},"end":{"line":1,"column":1352}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div data-dishId=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" style=\"margin-top:8px\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ingredientsList") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":1,"column":165},"end":{"line":1,"column":1335}}})) != null ? stack1 : "")
    + " </div> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow data-widget=\"widget/form/checkbox-master\" style=\"margin-bottom:8px;font-weight:bold\" class=\"mp-recipefull-name\"><icon class=\"color-branded\" style=\"font-size:24px;margin: 0 5px 0 0;vertical-align: middle;\"></icon><flexauto style=\"overflow:hidden;text-overflow:ellipsis\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</flexauto><icon data-fw-onclick=\"accordionclick\" style=\"opacity:0.5\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_chevron_down",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":548},"end":{"line":1,"column":577}}}))
    + "</icon></flexrow> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ingredientsList") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":595},"end":{"line":1,"column":942}}})) != null ? stack1 : "")
    + " ";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow data-widget=\"widget/form/checkbox\" style=\"margin-top:4px;\"><input type=\"checkbox\" class=\"mp-dish-ingredient\" style=\"display:none\" checked value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><icon class=\"color-branded\" style=\"font-size:24px;margin: 0 15px;vertical-align: middle;\"></icon><flexauto> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"fullname") : depth0), depth0))
    + "</flexauto></flexrow> ";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow data-widget=\"widget/form/checkbox\" style=\"margin-bottom:8px;font-weight:bold\" class=\"mp-recipefull-name\"><input type=\"checkbox\" style=\"display:none\" checked value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><icon class=\"color-branded\" style=\"font-size:24px;margin: 0 5px 0 0;vertical-align: middle;\"></icon><flexauto style=\"overflow:hidden;text-overflow:ellipsis\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</flexauto></flexrow> ";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"blockmargin\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.pickempty",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1387},"end":{"line":1,"column":1410}}}))
    + "</div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span></span> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dishes") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":14},"end":{"line":1,"column":1424}}})) != null ? stack1 : "");
},"useData":true});
export default TPL;